import api from "../api";
import notify from "devextreme/ui/notify";
import {getDictItems } from "./actions";

const createError = (msg) => ({
  errors: [
    {
      target: null,
      message: msg || "Не удалось выполнить запрос"
    }
  ]
});

const logError = message =>
  notify(
    {
      closeOnClick: true,
      closeOnOutsideClick: true,
      message
    },
    "error"
  );

const logSuccess = message =>
  notify(
    {
      closeOnClick: true,
      closeOnOutsideClick: true,
      message
    },
    "success"
  );

  const CREATE_DICT_ITEM_REQUEST = "CREATE_DICT_ITEM_REQUEST";
  const CREATE_DICT_ITEM_COMPLETED = "CREATE_DICT_ITEM_COMPLETED";
  const CREATE_DICT_ITEM_ERROR = "CREATE_DICT_ITEM_ERROR";

  const UPDATE_DICT_ITEM_REQUEST = "UPDATE_DICT_ITEM_REQUEST";
  const UPDATE_DICT_ITEM_COMPLETED = "UPDATE_DICT_ITEM_COMPLETED";
  const UPDATE_DICT_ITEM_ERROR = "UPDATE_DICT_ITEM_ERROR";

  function createDictItemRequest() {
    return {
      type: CREATE_DICT_ITEM_REQUEST,
      isCreatingItem: true
    };
  }

  function createDictItemCompleted(createdItem) {
    return {
      type: CREATE_DICT_ITEM_COMPLETED,
      isCreatingItem: false,
      createdItem
    };
  }

  function createDictItemError(itemCreationError) {
    return {
      type: CREATE_DICT_ITEM_ERROR,
      isCreatingItem: false,
      itemCreationError
    };
  }

  function updateDictItemRequest() {
    return {
      type: UPDATE_DICT_ITEM_REQUEST,
      isUpdatingItem: true
    };
  }

  function updateDictItemCompleted(updatedItem) {
    return {
      type: UPDATE_DICT_ITEM_COMPLETED,
      isUpdatingItem: false,
      updatedItem
    };
  }

  function updateDictItemError(itemUpdatingError) {
    return {
      type: UPDATE_DICT_ITEM_ERROR,
      isUpdatingItem: false,
      itemUpdatingError
    };
  }

//dicttype: 1-referenceType
  export function createDictItem(data, dicttype) {
    console.log(dicttype);
    return dispatch => {
      dispatch(createDictItemRequest());
      return api
        .createDictItem(data, dicttype)
        .then(response => {
          if (response.status === 200) {
            dispatch(createDictItemCompleted(response.data));
            dispatch(getDictItems(dicttype));
          } else {
            return Promise.reject(response);
          }
          return Promise.resolve();
        })
        .catch(err => {
          if (err.response && err.response.status === 400) {
            let message = err.response;
            if (err.response.data && err.response.data.errors) {
              message = err.response.data.errors.map(({ message }) => message).join(", ");
            }
            logError(message);
            dispatch(createDictItemError(message));
          } else {
            logError(err);
            dispatch(createDictItemError(createError("Не удалось отправить запрос добавления записи")));
          }
        });
    };
  }

  export function updateDictItem(id, data, dicttype) {
    return (dispatch, getState) => {
      dispatch(updateDictItemRequest());
      return api.updateDictItem(id, data, dicttype)
        .then(response => {
          if (response.status === 200) {
            logSuccess("Успешно обновлено");
            dispatch(updateDictItemCompleted(response.data));
            dispatch(getDictItems(dicttype));
          } else {
            return Promise.reject(response);
          }
          return Promise.resolve();
        })
        .catch(err => {
          if (err.response && err.response.status === 400) {
            let message = err.response;
            if (err.response.data && err.response.data.errors) {
              message = err.response.data.errors.map(({ message }) => message).join(", ");
            }

            logError(message);
            dispatch(updateDictItemError(message));
          } else {
            logError(err);
            dispatch(updateDictItemError(createError("Не удалось отправить запрос на обновление данных")));
          }
        });
    };
  }

  export default {
    CREATE_DICT_ITEM_REQUEST,
    CREATE_DICT_ITEM_COMPLETED,
    CREATE_DICT_ITEM_ERROR,

    UPDATE_DICT_ITEM_REQUEST,
    UPDATE_DICT_ITEM_COMPLETED,
    UPDATE_DICT_ITEM_ERROR,

    createDictItem,
    updateDictItem
  }
